module.exports = __webpack_public_path__ + "img/David González_Diseño.a6ab9f4c.png";